import { CellSelect, ICellSelect } from '@aleph/supergrid';
import { forwardRef } from 'react';
import { SelectCellEditorComponents } from '@aleph/shared-components';
import { useQuery } from '@apollo/client';
import { GroupOptimizationGoal, PixelEventsDocument } from 'wb-reddit/graphql/generated';
import { startCase } from 'lodash';
import { ICellEditor } from 'ag-grid-community';

const GroupOptimizationGoalCellEditor = forwardRef<ICellEditor, ICellSelect>(((
	params,
	ref,
) => {
	const { data, loading } = useQuery(PixelEventsDocument, {
		variables: { adAccountId: params.data?.parent?.parent?.adAccount?.adAccountId },
	});

	let options = data?.pixelLastFiredAt?.map((pixel) => ({
		label: startCase((pixel ?? '').toLowerCase()),
		value: pixel,
	})) ?? [];

	if (options.length === 0 && !loading) {
		options = [{
			label: 'Clicks',
			value: GroupOptimizationGoal.Clicks,
		}];
	}

	return (
		<CellSelect
			{...params}
			ref={ref}
			options={options}
			components={SelectCellEditorComponents}
			isLoading={loading}
		/>
	);
}));

export default GroupOptimizationGoalCellEditor;
